import { render, staticRenderFns } from "./Apotheke.vue?vue&type=template&id=3f79a24a&scoped=true"
import script from "./Apotheke.vue?vue&type=script&lang=js"
export * from "./Apotheke.vue?vue&type=script&lang=js"
import style0 from "./Apotheke.vue?vue&type=style&index=0&id=3f79a24a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f79a24a",
  null
  
)

export default component.exports